<template>
	<BaseModal :show="show" :horizontal-alignment="horizontalAlignment" :vertical-alignment="verticalAlignment">
		<form class="flex flex-col h-fit w-[572px] bg-neutral">
			<div class="flex flex-row align-middle">
				<p class="text-2xl font-bold leading-7">Contact us</p>
				<img src="@/assets/images/icon/dismiss.svg" alt="Dismiss" title="Dismiss" class="ml-auto cursor-pointer" @click="dismiss">
			</div>

			<div class="border-b border-neutral w-full h-[2px] my-6"></div>

			<InputText label="First name*" type="text" placeholder="Enter your first name" input-height="h-12"
								 v-model="first_name" :errors="error" error-field="messages.first_name" />

			<InputText label="Last name*" type="text" placeholder="Enter your last name" input-height="h-12"
								 v-model="last_name" class="mt-2" :errors="error" error-field="message.last_name" />

			<InputText label="Email*" type="email" placeholder="Enter email address" input-height="h-12"
								 v-model="email" class="mt-2" :errors="error" error-field="message.email" />

			<Combobox id="combo_support_message_subjects" class="mt-2" v-model="subject" :items="subjects" title="Subject*" placeholder="Select subject" input-height="h-12" :readonly="true" />

			<InputText label="Message*" type="textarea" placeholder="Enter your message"
								 v-model="message" class="mt-6" :errors="error" error-field="message.message" />

			<SubmitButton class="w-full" label="Send Message" :loading="isLoading" @click="sendMessage" />
			<ValidationError class="mt-4" :errors="error" :field="null" />
		</form>
	</BaseModal>
</template>

<script setup lang="js">
import InputText from '@/components/Forms/InputText.vue'
import { onMounted, ref, watch } from 'vue'
import { useAuthStore } from '@/stores/authStore.js'
import ValidationError from '@/components/Forms/InputError.vue'
import { supportMessageApi } from '@/api/Support/SupportMessageApi.js'
import { Toaster } from '@/models/utils/Toaster.js';
import SubmitButton from '@/components/Forms/Buttons/SubmitButton.vue'
import BaseModal from '@/components/Alerts/BaseModal.vue'
import { ModalHorizontalAlignment, ModalVerticalAlignment } from '@/components/Alerts/ModalAlignment.js'
import Combobox from '@/components/Forms/Combobox.vue'
import { userApi } from '@/api/User/UserApi.js'
import { isArray } from 'lodash/lang.js'

const isLoading = ref(false)
const error = ref(null)
const user = useAuthStore().getAuth?.user()
const first_name = ref(user?.given_name)
const last_name = ref(user?.family_name)
const email = ref(user?.email)
const subject = ref(null)
const subjects = ref([])
const message = ref('')
const toaster = new Toaster()

const emit = defineEmits(['dismiss'])

const props = defineProps({
	show: { type: Boolean, default: false },
	horizontalAlignment: {
		type: String,
		default: ModalHorizontalAlignment.Center
	},
	verticalAlignment: {
		type: String,
		default: ModalVerticalAlignment.Center
	},
})

watch(
	() => props.show,
	() => {
		first_name.value = user?.given_name
		last_name.value = user?.family_name
		email.value = user?.email
		message.value = ''
	}
)

onMounted(() => {
	const tenant = useAuthStore().getAuth?.tenantInfo()

	if (tenant) {
		handleTenant(tenant)
	} else {
		userApi.getTenantByHostname(window.location.hostname, (tenant) => {
			handleTenant(tenant)
		})
	}
})

function handleTenant(tenant) {
	const settings = JSON.parse(tenant.settings_json)
	subjects.value = settings.support_message_subjects.value.split('\n')
	subject.value = (isArray(subjects.value) && subjects.value.length > 0) ? subjects.value[0] : 'Program Questions'
}

function sendMessage()
{
	isLoading.value = true
	error.value = null

	supportMessageApi.insert({
			'message': {
				'user_id': user?.id,
				'first_name': first_name.value,
				'last_name': last_name.value,
				'email_address': email.value,
				'subject': subject.value,
				'message': message.value,
			}
		}, () =>
		{
			toaster.success('Message sent!')

			isLoading.value = false
			dismiss()
		},
		(e) =>
		{
			isLoading.value = false
			error.value = e.showErrorBanner()
		})
}

function dismiss() {
	emit('dismiss')
}

</script>